import { FULL_TEXT } from '../constants/nameFiltersTopic';
import * as QueryParams from '../constants/queryParams';

const reduceParams = (params = {}) => {
  let newParams = {};

  const keyParams = [...Object.values(QueryParams), FULL_TEXT];

  Object.entries(params)
    .filter((item) => !!item[1])
    .forEach(([index, item]) => {
      if (keyParams.includes(index)) {
        newParams = { ...newParams, [index]: item };
      } else {
        // We use a proper format to each key so it can be parsed by the controller
        newParams = { ...newParams, [`query[${index}]`]: item };
      }
    });

  return newParams;
};

export default reduceParams;
